// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__+KGzP","hidden":"Header_hidden__x4XnU"};